import { Command } from '@/app/common/base/command'

export class SignOtdCommand extends Command {

    public async run(productActionId: string, data: object) {
        await this.client.post(`/api/products/otds/actions/${productActionId}/sign`, { data })
    }

}
